import React from 'react';
import ReactDOM from 'react-dom';

import 'typeface-maven-pro';
import './lib/icons';

import App from './components/App';

ReactDOM.render(<App />, document.getElementById('root'));
